import { render, staticRenderFns } from "./List-carteira-vacinacao.vue?vue&type=template&id=1d39fc94&scoped=true&"
import script from "./List-carteira-vacinacao.vue?vue&type=script&lang=js&"
export * from "./List-carteira-vacinacao.vue?vue&type=script&lang=js&"
import style0 from "./List-carteira-vacinacao.vue?vue&type=style&index=0&id=1d39fc94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d39fc94",
  null
  
)

export default component.exports